import React from 'react';
import _ from 'lodash';

import {
  InputLabel as BaseInputLabel,
  Typography as BaseTypography,
  Link as UiLink
} from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';



interface IContainerDivProps {
  disableMarginBottom?: boolean;
}

const ContainerDiv = styled('div', {
  shouldForwardProp: prop =>
    prop !== 'disableMarginBottom'
})<IContainerDivProps>(({theme, disableMarginBottom}) => ({
  marginRight: theme.spacing(6),
  marginBottom: !disableMarginBottom ? theme.spacing(4) : 0,
  display: 'flex',
  flexDirection: 'column'
}));

const InputLabel = styled(BaseInputLabel)(({theme}) => ({
  marginBottom: theme.spacing(1)
}));

const Typography = styled(BaseTypography)(() => ({
  fontSize: 16
}));



export interface IProps {
  label: string;
  value: string | JSX.Element;

  /**
   * Only applied if `value` is a `string`.
   */
  toRoute?: string;

  disableMarginBottom?: boolean;
}

export const FC: React.FC<IProps> = props => {
  const elStringValue = _.isString(props.value) ? (
    <Typography>
      {props.value || "--"}
    </Typography>
  ) : null;

  const elStringValueWithLink = elStringValue && props.toRoute ? (
    <UiLink
      component={RouterLink}
      to={props.toRoute}>
      {elStringValue}
    </UiLink>
  ) : null;



  return (
    <ContainerDiv disableMarginBottom={props.disableMarginBottom}>
      <InputLabel
        color="info">
        {props.label}
      </InputLabel>

      {elStringValueWithLink || elStringValue || props.value}
    </ContainerDiv>
  );
};



const RowDiv = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap'
}));

interface IRowProps {
  children?: React.ReactNode;
}

export const Row: React.FC<IRowProps> = props => (
  <RowDiv>
    {props.children}
  </RowDiv>
);
